<template>
  <loginless-layout :title="$t('profile.password.title')">
    <loadable :loading="isBusy" only-hide>
      <v-alert info :value="true">{{ $t('changePasswordDescription') }}</v-alert>

      <password-form @save="save" :error="error" />
    </loadable>
  </loginless-layout>
</template>

<script>
import LoginlessLayout from '@/components/LoginlessLayout'
import PasswordForm from '@/components/PasswordForm'
import User from '@/models/User'
import defaultRoutes from '@/router/default'
import Store from '@/store'

export default {
  data () {
    return {
      isBusy: false,
      error: null
    }
  },
  beforeRouteEnter (from, to, next) {
    if (!Store.auth.user) {
      return next('/')
    }
    return next()
  },
  methods: {
    save (password) {
      this.isBusy = true

      User
        .setPassword({
          password: password
        })
        .then(() => {
          this.isBusy = false
          this.$store.auth.password = password
          this.$store.auth.user.changePasswordAfterLogin = false
          this.$router.push(defaultRoutes[this.$store.auth.user.role] || '/')
        })
        .catch(err => {
          console.error(err)
          this.isBusy = false
          this.error = this.$t('savingFailed') + '.<br />' + err
        })
    }
  },
  components: {
    LoginlessLayout,
    PasswordForm
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PasswordChange.vue?8f74788e